export * from '@primeuix/themes/lara/message';
export { default } from '@primeuix/themes/lara/message';
